<div class="stepper">
  <div class="stepper__container">
    <div
      class="stepper__progress"
      [ngStyle]="{ 'width': currentPercentage >= 100 ? 100 + '%' : currentPercentage + '%' }"
    ></div>
    <div
      *ngFor="let step of steps; let stepNumber = index"
      class="stepper__step"
      [ngClass]="{
        'stepper__step--before': ((stepNumber + 1) < currentStep) || currentPercentage === 101,
        'stepper__step--current': ((stepNumber + 1) === currentStep) && currentPercentage !== 101,
        'stepper__step--after': ((stepNumber + 1) > currentStep)
      }"
    ></div>
  </div>
  <p
    class="stepper__section"
    [ngClass]="{
      'stepper__section--left': (steps.length === 3) && currentStep === 1,
      'stepper__section--right': (steps.length === 3) && currentStep === 3
    }"
  >{{ steps[currentStep - 1].title | translate }}</p>
</div>
